<template>
  <Card class="p-5">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </template>
      <div v-for="(item, key, index) in data" :key="index">
        <LineChart :title="key" :data="convertAsData(item)" class="p-5" />
      </div>
    </b-skeleton-wrapper>
  </Card>
</template>

<script>
import ApiService from '@/core/services/api.service'

export default {
  name: 'Performance',
  data() {
    return {
      loading: false,
      data: '',
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.getDatas()
        .then((res) => {
          if (res && res.data) this.data = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDatas() {
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/virtual-machines/${this.getVmId}/metrics/daily`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    convertAsData(data) {
      let series = [
        {
          name: '',
          data: [],
        },
      ]

      let categories = []

      for (const [key, value] of Object.entries(data)) {
        // s.push({
        //   name: this.$customFunctions.dateFormatEpoc(key, 'hh:mm:ss'),
        //   data: [
        //       value,
        //   ],
        // })
        series[0].data.push(value)
        categories.push(this.$customFunctions.dateFormatEpoc(key, 'hh:mm:ss'))
      }

      return { series: series, categories: categories }
    },
  },
}
</script>
